import { IRestaurantCategory } from '@/shared/model/restaurant-category.model';
import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { Costs, IRestaurantList, IRestaurants, Types, MinDeliveries, SortByTypes } from './types';

export const getters: GetterTree<IRestaurants, RootState> = {
  getRestaurantsList(state): IRestaurantList[] {
    return state.restaurants;
  },

  getRestaurantCategories(state): IRestaurantCategory[] {
    return state.categories;
  },

  getSelectedCategory(state): number {
    return state.selectedCategory;
  },

  getRestaurantsByCategory(state): IRestaurantList[] {
    let restaurantsByCategory: IRestaurantList[] = [];

    if (state.selectedCategory === 0) {
      restaurantsByCategory = state.restaurants;
    } else {
      state.restaurants?.forEach(restaurant => {
        restaurant.restaurantCategories?.forEach(category => {
          if (category.id === state.selectedCategory) {
            restaurantsByCategory.push(restaurant);
          }
        });
      });
    }

    return restaurantsByCategory;
  },

  getFilteredRestaurantsList(state, getters): IRestaurantList[] {
    let filteredRestaurants: IRestaurantList[] = getters.getRestaurantsByCategory;

    state.types.deliver && state.types.pickup
      ? filteredRestaurants
      : (filteredRestaurants = filteredRestaurants.filter(
          restaurant => restaurant.deliver === state.types.deliver || restaurant.pickup === state.types.pickup
        ));

    filteredRestaurants = filteredRestaurants.filter(restaurant => restaurant.ratingSummary.average >= state.ratings);

    if (state.costs.free) {
      filteredRestaurants = filteredRestaurants.filter(restaurant => restaurant.deliverySpec.deliveryCost <= 0);
    }

    if (state.minDeliveries.noPreference) {
      filteredRestaurants = filteredRestaurants.filter(restaurant => restaurant.deliverySpec.minOrder <= 0);
    }

    return filteredRestaurants;
  },

  getSortedRestaurants(state, getters): IRestaurantList[] {
    let sortedRestaurants: IRestaurantList[] = getters.getFilteredRestaurantsList;

    const sortItems = (a, b): number => {
      if (a < b) return 1;
      else if (a > b) return -1;
      else return 0;
    };

    switch (state.sortBy) {
      case SortByTypes.DISCOUNT:
        sortedRestaurants = sortedRestaurants.sort((a, b) => sortItems(a.foodDiscount, b.foodDiscount));
        break;

      case SortByTypes.REVIEW:
        sortedRestaurants = sortedRestaurants.sort((a, b) => sortItems(a.ratingSummary.average, b.ratingSummary.average));
        break;

      case SortByTypes.DISTANCE:
        sortedRestaurants;
        break;

      case SortByTypes.POPULARITY:
        sortedRestaurants = sortedRestaurants.sort((a, b) => sortItems(a.ratingSummary.ratings, b.ratingSummary.ratings));
        break;

      case SortByTypes.DELIVERY_COSTS:
        sortedRestaurants = sortedRestaurants.sort((a, b) => sortItems(b.deliverySpec.deliveryCost, a.deliverySpec.deliveryCost));
        break;

      case SortByTypes.DELIVERY_TIME:
        // sortedRestaurants = sortedRestaurants.sort((a, b) => sortItems(a.deliverySpec.deliveryTime, b.deliverySpec.deliveryTime));
        sortedRestaurants;
        break;

      case SortByTypes.MIN_ORDER_AMOUNT:
        sortedRestaurants = sortedRestaurants.sort((a, b) => sortItems(b.deliverySpec.minOrder, a.deliverySpec.minOrder));
        break;

      default:
        sortedRestaurants;
        break;
    }

    return sortedRestaurants;
  },

  getSearchedRestaurants(state, getters): IRestaurantList[] {
    const sortedRestaurants: IRestaurantList[] = getters.getSortedRestaurants;
    const result: IRestaurantList[] = [];

    if (state.search) {
      sortedRestaurants.forEach(restaurant => {
        if (restaurant.name.toLocaleLowerCase().includes(state.search.toLocaleLowerCase())) {
          result.push(restaurant);
        } else {
          restaurant.restaurantCategories.forEach(category => {
            if (category.name.toLocaleLowerCase().includes(state.search.toLocaleLowerCase())) {
              result.push(restaurant);
            }
          });
        }
      });
    }
    return result;
  },

  getRestaurants(state, getters): IRestaurantList[] {
    if (state.search) {
      return getters.getSearchedRestaurants;
    } else {
      return getters.getSortedRestaurants;
    }
  },

  getTypes_deliver(state): boolean {
    return state.types.deliver;
  },
  getTypes_pickup(state): boolean {
    return state.types.pickup;
  },

  getRatings(state): number {
    return state.ratings;
  },

  getCosts_free(state): boolean {
    return state.costs.free;
  },
  getCosts_all(state): boolean {
    return state.costs.all;
  },

  getMinDeliveries_noPreference(state): boolean {
    return state.minDeliveries.noPreference;
  },
  getMinDeliveries_all(state): boolean {
    return state.minDeliveries.all;
  },

  getTypes(state): Types {
    return state.types;
  },
  getCosts(state): Costs {
    return state.costs;
  },
  getMinDeliveries(state): MinDeliveries {
    return state.minDeliveries;
  },

  getSortBy(state): SortByTypes {
    return state.sortBy;
  },

  getSearch(state): string {
    return state.search;
  },
};
